import React from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';

/**
 * One-click copy to clipboard. Fires a toast on success/failure so the
 * caller doesn't repeat that wiring.
 *
 *   <CopyButton value={apiKey} label="Copy key" />
 */
export default function CopyButton({
  value,
  label = 'Copy',
  size = 'small',
  variant = 'outlined',
  successMessage = 'Copied',
  failureMessage = 'Copy failed',
  sx,
}) {
  const onClick = () => {
    if (!navigator.clipboard) {
      toast.error(failureMessage);
      return;
    }
    navigator.clipboard.writeText(String(value || '')).then(
      () => toast.success(successMessage),
      () => toast.error(failureMessage)
    );
  };
  return (
    <Button size={size} variant={variant} onClick={onClick} sx={sx}>
      {label}
    </Button>
  );
}
